import { config } from "../config/config";
import { GET, POST } from "./restUtils";

export const sendFirstMessage = async ({
  clinicId,
  email,
  fullName,
  firstMessage,
  phone,
}) => {
  // test.dentistfind.com/api/v1/chat_widgets?current_office=58ff6485421aa9383b00000a&email=jacktesting12341212@gmail.com&first_name=AnujTestStaging2hj&message=Hi.... this side anujwedfgfdsa&phone=9142326785
  return POST(
    `${config.BASE_URL}/api/v1/chat_widgets?current_office=${clinicId}&email=${email}&first_name=${fullName}&message=${firstMessage}&phone=${phone}`
  );
};

export const sendMessageToOffice = async ({
  chatToken,
  message,
  file,
  clinicId,
}) => {
  const formData = new FormData();
  formData.append("chatwidget_image", file);
  return fetch(
    `${config.BASE_URL}/api/v1/chat_widgets/chat?chat_token=${chatToken}&current_office=${clinicId}a&message=${message}`,
    {
      method: "POST",
      body: formData,
    }
  );
};

export const getMessages = async ({ chatToken, pageParam }) => {
  return GET(
    `${config.BASE_URL}/api/v1/chat_widgets?chat_token=${chatToken}&page=${pageParam}&sort=desc`
  );
};

export const getLogoUrl = async (clinicId) => {
  return GET(
    `${config.BASE_URL}/api/v1/chat_widgets/office_details?current_office=${clinicId}`
  );
};

export const getOfficeHours = async (clinicId) => {
  return GET(`${config.BASE_URL}/api/v1/dentistry/${clinicId}/office_hour`);
};

// export const getMessages = async ({ chatToken, page }) => {
//   return GET(
//     `${config.BASE_URL}/api/v1/chat_widgets?chat_token=${chatToken}&page=1&sort=desc`
//   );
// };
